// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer_wrapper__3kh1u","footerText":"footer_footerText__gGzXI"};